import { jsonPost, get } from 'api'

import { CALLBACK_URL } from './constants'

export const generateOrder = () => jsonPost(`${GRS_RESERVATIONS_SERVICE}/GenerateOrder`, { ReservationId: '' })

export const setIngenicoPaymentResponse = (orderId, apiLanguageCode) =>
    get(`${GRS_RESERVATIONS_SERVICE}/SetIngenicoPaymentResponse`, {
        OrderId: orderId,
        ISOCode: apiLanguageCode,
        ConnectionId: orderId + Math.floor(Date.now()),
        eDataLocationId: '999014', // TODO: currently should be hardcoded
    })

export const getProcessorManager = () =>
    get(`${GRS_RESERVATIONS_SERVICE}/GetProcessorManager`, {
        locid: '999014', // TODO: currently should be hardcoded
    }).then(response => response.text())

export const getIngenicoSHA = params => {
    const queryParams = {
        oid: params['ALIAS.ORDERID'],
        mode: 'tkn', // TODO: currently should be hardcoded
        locid: '999014', // TODO: currently should be hardcoded
        'CARD.BRAND': params['CARD.BRAND'],
        'PARAMETERS.ACCEPTURL': params['PARAMETERS.ACCEPTURL'],
        'PARAMETERS.EXCEPTIONURL': params['PARAMETERS.EXCEPTIONURL'],
        'LAYOUT.TEMPLATENAME': params['LAYOUT.TEMPLATENAME'],
        'LAYOUT.LANGUAGE': params['LAYOUT.LANGUAGE'],
    }
    return get(`${GRS_RESERVATIONS_SERVICE}/GetIngenicoSHA`, queryParams).then(response => response.text())
}

export const authoriseTransaction = (orderId, token, card, paymentTotal, locationId, apiLanguageCode = 'EN') =>
    jsonPost(
        `${GRS_RESERVATIONS_SERVICE}/AuthoriseTransaction`,
        {
            ReservationInfoData: {
                CCID: card.id,
                ID: '-1',
                INVOICE: false,
                ISOLANGCODE: apiLanguageCode,
                LOC: locationId,
                ORDID: orderId,
                AMT: paymentTotal,
                TOKEN: token,
                ACPTURL: location.origin + CALLBACK_URL,
                DCLNURL: location.origin + CALLBACK_URL,
                EXPURL: location.origin + CALLBACK_URL,
                BROWSERCOLORDEPTH: screen.colorDepth,
                BROWSERJAVAENABLED: navigator.javaEnabled(),
                BROWSERLANGUAGE: navigator.language,
                BROWSERSCREENHEIGHT: screen.height,
                BROWSERSCREENWIDTH: screen.width,
                BROWSERTIMEZONE: new Date().getTimezoneOffset(),
            },
        },
        {
            'Accept-Language': apiLanguageCode,
        }
    ).catch(error => {
        throw new Error(error.message)
    })

export const acceptIngenicoPayment = details => get(`${GRS_RESERVATIONS_SERVICE}/IngenicoAcceptedPayment`, details)
